<template>
  <div class="dialog-pro-add">
    <el-dialog class="dialog-pro m-common-pro-dialog" :title="pageType == 'edit' ?'项目设置': '新建项目'" :show-close="false"
      :visible.sync="dialogVisible" :width="'900px'">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item class="mb-30" prop="projectName">
          <el-input v-model="form.projectName" placeholder="项目名称" />
        </el-form-item>

        <el-form-item class="mb-30">
          <el-input v-model="form.planPeriod" placeholder="展览周期" />
        </el-form-item>

        <el-form-item class="mb-30">
          <el-date-picker v-model="form.planTime" value-format="yyyy-MM-dd" type="date" placeholder="计划开展时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item class="mb-30">
          <el-input v-model="form.planPlace" placeholder="展览地点" />
        </el-form-item>

        <el-form-item class="mb-20">
          <el-select v-model="form.planDept" placeholder="展览部门" style="display:block;">
            <el-option v-for="item in department" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="mb-20" prop="charge">
          <el-select v-model="form.charge" clearable filterable placeholder="负责人" style="display:block;">
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item class="mb-20" prop="charge1">
          <el-select v-model="form.charge1" filterable multiple placeholder="参与人" style="display:block;">
            <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

      </el-form>
      <div class="dialog-footer tr mt-30">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      form: {},
      pageType: '',
      detailId: '',
      department: [],
      userList: [],
      rules: {
        projectName: [{ required: true, message: '必填', trigger: 'blur' }],
      }
    }
  },
  methods: {
    init(type, detailId) {
      this.pageType = type // add 新增 edit 编辑 
      this.detailId = detailId || ''
      this.dialogVisible = true
      // 获取焦点
      // this.$nextTick(() => {
      //   this.$refs.focusInput.$el.querySelector('input').focus()
      // })
      if (this.detailId) {
        this.getDetail()
      }
      this.getProjectTypeList()
    },
    // 获取项目类型列表
    getProjectTypeList() {
      this.$http.get('/job/employeeDict').then(res => {
        if (res.success) {
          const { department, user } = res.result
          this.department = department
          this.userList = user
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 新建项目
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let url = ''
          if (this.pageType == 'add') {
            url = '/project/addProject'
          } else if (this.pageType == 'edit') {
            url = '/project/updateProject'
            this.form.projectId = this.detailId
          }
          console.log(this.form)
          this.$http.post(url, {
            ...this.form, //	项目名称
          }).then(res => {
            if (res.success) {
              // this.$parent.getData()
              this.dialogVisible = false
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false
        }
      })
    },
    // 重置
    resetForm() {
      this.$refs['form'].resetFields()
    },

    getDetail() {
      this.$http.post('/project/getProjectInfo', {
        projectId: this.detailId
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          let results = res.result
          this.form = {
            projectName: results.projectName,
            planPeriod: results.planPeriod,
            planTime: results.planTime,
            planPlace: results.planPlace,
            planDept: results.planDept,
            charge: results.charge,
            charge1: results.charge1
          }
        } else {
          this.$message.error(res.message)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-pro {
  /deep/ .el-dialog {
    padding-right: 20px;
  }
  .dialog-pro-wrap {
    padding-right: 10px;
    max-height: 700px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .el-card.is-always-shadow {
    // box-shadow: none;
    box-shadow: 0px 1px 10px 0px rgba(238, 239, 245, 1);
    border-radius: 4px;
  }
  .el-card {
    border: 1px solid transparent;
    background: transparent;
    &.active {
      border: 1px solid rgba(5, 144, 255, 1);
    }
  }
  .box {
    margin-bottom: 30px;
    cursor: pointer;
  }
}
</style>


